document.addEventListener("DOMContentLoaded", function() {
  // Chỉ xử lý trong cart template, không ảnh hưởng đến cart drawer
  const cartTemplate = document.querySelector('#MinimogCart');
  if (!cartTemplate) return;
  
  // Khi click nút Edit
  cartTemplate.querySelectorAll(".js-item-edit").forEach(button => {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      
      // Lấy ảnh từ cart item
      let cartItem = e.currentTarget.closest(".m-cart-item");
      let imageElement = cartItem.querySelector(".m-cart-item__image img");
      let imageSrc = imageElement ? imageElement.src : '';
      let productUrl = e.currentTarget.dataset.product;
      let lineItemId = e.currentTarget.dataset.lineItemId;
      
      // Set data cho modal
      let modalImage = document.querySelector(".js-edit-product-image");
      let editLink = document.querySelector(".js-edit-product-link");
      
      if (modalImage) {
        modalImage.src = imageSrc;
      }
      
      if (editLink) {
        editLink.href = productUrl;
        editLink.dataset.lineItemId = lineItemId;
      }
      
      // Hiển thị modal
      let modal = document.querySelector(".edit-product");
      if (modal) {
        modal.classList.add("is-open");
        document.body.style.overflow = "hidden";
      }
    });
  });

  // Khi click nút Cancel hoặc background
  document.querySelectorAll(".js-item-close").forEach(button => {
    button.addEventListener("click", function(e) {
      e.preventDefault();
      
      // Ẩn modal
      let modal = document.querySelector(".edit-product");
      if (modal) {
        modal.classList.remove("is-open");
        document.body.style.overflow = "";
      }
    });
  });

  // Đóng modal khi click background
  document.querySelectorAll(".edit-product__background").forEach(background => {
    background.addEventListener("click", function(e) {
      e.preventDefault();
      
      let modal = document.querySelector(".edit-product");
      if (modal) {
        modal.classList.remove("is-open");
        document.body.style.overflow = "";
      }
    });
  });

  // Đóng modal khi nhấn ESC
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      let modal = document.querySelector(".edit-product");
      if (modal && modal.classList.contains("is-open")) {
        modal.classList.remove("is-open");
        document.body.style.overflow = "";
      }
    }
  });
});
